// Chakra imports
import { Flex, Image, Text, useColorModeValue } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';

// Custom components
import { HSeparator } from 'components/separator/Separator';
import brilliantLogo from 'assets/img/auth/brilliant-logo.png';

export function SidebarBrand(props: { mini: boolean; hovered: boolean }) {
  const { mini, hovered } = props;
  const navigate = useNavigate();
  let logoColor = useColorModeValue('navy.700', 'white');

  return (
    <Flex alignItems="center" flexDirection="column">
      <Image
        src={brilliantLogo}
        alt="Brilliant Events"
        w="175px"
        my="32px"
        cursor="pointer"
        onClick={() => navigate('/admin/stats/overview')}
        display={
          mini === false
            ? 'block'
            : mini === true && hovered === true
            ? 'block'
            : 'none'
        }
      />
      <Text
        display={
          mini === false
            ? 'none'
            : mini === true && hovered === true
            ? 'none'
            : 'block'
        }
        fontSize={'30px'}
        fontWeight="800"
        color={logoColor}
      >
        B
      </Text>
      <HSeparator mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;
